import React from "react";
import SectionTitle from "../components/Utilities/SectionTitle";
import ThemeTabsContainer from "../components/ThemeSections/ThemeTabsContainer";

const ThemeStoreLayout = () => {
  return (
    <>
      <section className="portfolio-area section-gap" id="portfolio">
        <div className="container">
          <SectionTitle sectionTitleText="Pick the one you like & Quick Start Your Project" />
          <ThemeTabsContainer />
        </div>
      </section>
    </>
  );
};

export default ThemeStoreLayout;
